import { createSelector } from "@reduxjs/toolkit";

export const selectAllCoupons = createSelector(
    (state) => state.coupons.coupons,
    (coupons) => Object.values(coupons)
);

export const selectRecentCoupons = createSelector(
    selectAllCoupons,
    (coupons) => coupons.slice(0, 6)
);

export const selectAllVendors = createSelector(
    (state) => state.vendors.vendors,
    (vendors) => Object.values(vendors)
);
